<span class="lang-segment__indicator" [style.transform]="indicatorTransform"></span>
<button type="button"
  class="lang-segment__btn"
  [class.lang-segment__btn--active]="firstActive"
  (click)="onBtnClick(locales[0], $event)">{{ labels[0] }}</button>
<button type="button"
  class="lang-segment__btn"
  [class.lang-segment__btn--active]="secondActive"
  (click)="onBtnClick(locales[1], $event)">{{ labels[1] }}</button>
